import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from '../TextField';
import mergeFormikProps from '../mergeFormikProps';

class IntegerMask extends React.PureComponent {
  render() {
    const { inputRef, onChange, name, min, max, ...restProps } = this.props;

    const isAllowed = values =>
      (values.floatValue >= min && values.floatValue <= max) || values.formattedValue === '';

    const onValueChange = values => {
      onChange({
        target: {
          value: values.floatValue,
          name,
        },
      });
    };

    return (
      <NumberFormat
        getInputRef={inputRef}
        onValueChange={onValueChange}
        isAllowed={isAllowed}
        decimalScale={0}
        name={name}
        {...restProps}
      />
    );
  }
}

IntegerMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

IntegerMask.defaultProps = {
  max: 32768,
  min: 0,
};

const IntegerField = ({ min, max, textAlign, InputProps, ...restProps }) => (
  <TextField
    InputProps={{
      inputComponent: IntegerMask,
      inputProps: {
        min,
        max,
        style: { textAlign },
      },
      ...InputProps,
    }}
    {...restProps}
  />
);

IntegerField.propTypes = {
  InputProps: PropTypes.object,
  max: PropTypes.number,
  min: PropTypes.number,
  textAlign: PropTypes.string,
  value: PropTypes.number,
};

IntegerField.defaultProps = {
  InputProps: null,
  max: 32768,
  min: 0,
  textAlign: null,
  value: null,
};

export default mergeFormikProps(IntegerField);
